import { render, staticRenderFns } from "./paymentDuigong.vue?vue&type=template&id=55253037&scoped=true"
import script from "./paymentDuigong.vue?vue&type=script&lang=js"
export * from "./paymentDuigong.vue?vue&type=script&lang=js"
import style0 from "./paymentDuigong.vue?vue&type=style&index=0&id=55253037&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55253037",
  null
  
)

export default component.exports